import { render, staticRenderFns } from "./RightBanner.vue?vue&type=template&id=2d45d85f"
import script from "./RightBanner.vue?vue&type=script&lang=js"
export * from "./RightBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports